import React, { FC, useState } from 'react';
import { Button } from '../../styled/buttons/Button';
import { Td, Tr } from '../../styled/table/table';
import { ApiKey } from '../../types/axios/apiKeys';
import { InputBlock } from '../form/input-block';
import useAxios from 'axios-hooks';
import { useAuth } from '../../hooks/useAuth';
import { isAxiosError, AUTH_ERROR } from '../../utils/axiosUtils';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../routes/RouterPaths';

interface IProps {
  keyData: ApiKey;
  setPostError: React.Dispatch<React.SetStateAction<boolean>>;
  fetchKeys: () => Promise<void>;
}

const buttonStyle = { padding: '5px 10px', maxWidth: 80 };
const SECRET_HOLDER = 'AAAA';

const KeyRow: FC<IProps> = ({ keyData, setPostError, fetchKeys }) => {
  const [userId, setUserId] = useState(keyData.userId || '');
  const [key, setKey] = useState(keyData.key);
  const [exchange, setExchange] = useState(keyData.exchangeName);
  const [secret, setSecret] = useState(SECRET_HOLDER);

  const navigate = useNavigate();
  const { token } = useAuth();
  const [, deleteKey] = useAxios<boolean>(
    {
      url: '/apiKey/delete',
      method: 'POST',
      headers: { authorization: token },
    },
    { manual: true },
  );

  const [, updateKey] = useAxios<boolean>(
    {
      url: '/apiKey/update',
      method: 'POST',
      headers: { authorization: token },
    },
    { manual: true },
  );

  const onDelete = async () => {
    setPostError(false);
    try {
      await deleteKey({
        data: { id: keyData.id },
      });
      await fetchKeys();
    } catch (error) {
      if (isAxiosError(error, AUTH_ERROR)) {
        navigate(RouterPaths.LOG_OUT);
      } else {
        setPostError(true);
      }
    }
  };

  const onUpdate = async () => {
    setPostError(false);
    try {
      await updateKey({
        data: {
          id: keyData.id,
          exchangeName: exchange,
          key: key,
          userId: userId,
          secret: secret === SECRET_HOLDER ? undefined : secret,
        },
      });
      await fetchKeys();
    } catch (error) {
      if (isAxiosError(error, AUTH_ERROR)) {
        navigate(RouterPaths.LOG_OUT);
      } else {
        setPostError(true);
      }
    }
  };

  return (
    <Tr>
      <Td>
        <InputBlock
          style={{ maxWidth: 100, width: '100%' }}
          value={exchange}
          onChange={e => {
            setExchange(e.target.value);
          }}
        />
      </Td>
      <Td>
        <InputBlock
          style={{ maxWidth: 300, width: '100%' }}
          value={key}
          onChange={e => {
            setKey(e.target.value);
          }}
        />
      </Td>
      <Td>
        <InputBlock
          style={{ maxWidth: 100, width: '100%' }}
          type="password"
          value={secret}
          onChange={e => {
            setSecret(e.target.value);
          }}
        />
      </Td>
      <Td>
        <InputBlock
          style={{ maxWidth: 120, width: '100%' }}
          value={userId}
          onChange={e => {
            setUserId(e.target.value);
          }}
        />
      </Td>
      <Td>
        <Button style={buttonStyle} blue onClick={onUpdate}>
          Update
        </Button>
      </Td>
      <Td>
        <Button style={buttonStyle} red onClick={onDelete}>
          Delete
        </Button>
      </Td>
    </Tr>
  );
};

export default KeyRow;
